<template>
    <div class="groups-card">
        <!-- Header -->
        <div class="groups-header cursor-pointer transition-opacity duration-200 hover:opacity-80">
            <h2 class="groups-title" @click="">Quick Links</h2>
            <!-- <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.296477 1.71L2.88648 4.3C3.27648 4.69 3.90648 4.69 4.29648 4.3L6.88648 1.71C7.51648 1.08 7.06648 0 6.17648 0H0.996477C0.106477 0 -0.333523 1.08 0.296477 1.71Z"
                    fill="white" />
            </svg> -->
        </div>
        <!-- <p class="groups-subtitle">Quick links</p> -->
        <!-- Group list
        <div> -->
        <div v-for="group in links" :key="group.label" class="group-item">
            <router-link :to="group.path" class="flex items-center gap-3 w-full hover:opacity-80">
                <component :is="group.icon" class="group-avatar" />
                <div class="group-info">
                    <p class="group-name">{{ group.label }}</p>
                </div>
            </router-link>
            <div class="group-followers">

            </div>
        </div>
        <!-- </div> -->
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";
import type { Component } from "vue";
import About_us from "@/components/Icons/About_us.vue";
import Help from "@/components/Icons/Help.vue";
import PrivacyPolicy from "@/components/Icons/PrivacyPolicy.vue";
import { useThemeScheme } from "@/composables/useThemeSchema";
const { isDarkMode } = useThemeScheme();
import { useRouter } from "vue-router";

const router = useRouter();
type QuickLink = {
    label: string;
    icon: Component;
    path: string;
};
const props = defineProps({
    links: {
        type: Array,
        default: () => [
            { label: "About Us", icon: About_us, path: "/about" },
            {
                label: "Help", icon: Help, path: "/user/sezushelp"
            },
            {
                label: "Privacy Policy", icon: PrivacyPolicy, path: "/privacy"
            },
        ] as QuickLink[],
    },
});
const links = props.links as QuickLink[];
const emit = defineEmits<{
    (e: "link-click", link: QuickLink): void;
}>();

const isOpen = ref(false);
const dropdownRef = ref<HTMLElement | null>(null);

// Toggle dropdown
const toggleDropdown = () => {
    isOpen.value = !isOpen.value;
};

// Handle link click
const onLinkClick = (link: QuickLink) => {
    emit("link-click", link);
    isOpen.value = false; // Close dropdown
};

// Close dropdown on outside click
const handleClickOutside = (event: Event) => {
    const target = event.target as Node | null;
    if (dropdownRef.value && target && !dropdownRef.value.contains(target)) {
        isOpen.value = false;
    }
};

onMounted(() => {
    document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
    document.removeEventListener("click", handleClickOutside);
});
const navigateToGroups = () => {
    router.push('/groups');
};
</script>

<style scoped>
.groups-card {
    background: var(--header-bg-light);
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    padding: 30px 12px 12px 12px;
    /* ✅ use spaces, not commas */
    width: 100%;
    border: 1px solid #f1f1f1;
    margin-top: 1rem;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid var(--border-leftbar-component);
    position: relative;
}

/* Header section */
.groups-header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -13px;
    left: 0px;
    display: flex;
    background-color: var(--container-head);
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    padding: 0.4rem;
    /* border-bottom: 1px solid #e5e7eb; */
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    width: 100%;
    cursor: pointer;
    transition: all 0.2s ease;
}

.groups-icon {
    width: 20px;
    height: 20px;
    color: #2563eb;
    /* blue-600 */
}

.groups-title {
    font-size: 18px;
    font-weight: 600;
    color: white;
}

.groups-subtitle {
    margin-top: 12px;
    color: #111827;
    font-size: 14px;
    margin-bottom: 12px;
    font-weight: 600
}

/* Each group item */
.group-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    /* border-bottom: 1px solid #F4E6FF;     */
    padding: 0.5rem;


}

.group-item:last-child {
    margin-bottom: 0;
}

/* Group avatar */
.group-avatar {
    width: 1rem;
    height: 1rem;
    border-radius: 1.5rem;
    object-fit: cover;
    border: 1px solid #d1d5db;
}

/* Group info text */
.group-info {
    margin-left: 12px;
    flex: 1;
}

.group-name {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-primary);
    cursor: pointer;

}

.group-name:hover {
    text-decoration: underline;
}

.group-category {
    font-size: 12px;
    color: #4849A1;
    font-weight: 600;
}

/* Follower count */
.group-followers {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #374151;
}

.online-dot {
    width: 8px;
    height: 8px;
    background-color: #4849A1;
    border-radius: 50%;
}

.followers-count {
    font-weight: 700;

}
</style>
